const initActionTypes = {
  INIT_MAIN: "INIT_MAIN",
};

export default initActionTypes;
